import * as React from "react";
import { LabelsLang } from "../../../resources/LabelsLang";

export interface IPatientContactInfoEditFooter {
    isFormValid: boolean;
    addElementTextLabel: string;
    text: LabelsLang;
    onAddElementClick: () => void;
    onCancelClick: () => void;
    onSaveElementsClick: () => void;
}

export const PatientContactInfoEditFooter = (props: IPatientContactInfoEditFooter) => (
    <>
        {
            props.isFormValid &&
            <div className="col-sm-12 text-center">
                <button
                    className="buttons-white padding-10px-vertical"
                    onClick={props.onAddElementClick}
                >
                    {props.addElementTextLabel}
                </button>
            </div>
        }

        <div className="col-sm-12 text-center">
            <button
                className="buttons-white"
                onClick={props.onCancelClick}
            >
                {props.text.CancelButton}
            </button>
            <button
                className="buttons-blue"
                onClick={props.onSaveElementsClick}
                disabled={!props.isFormValid}
            >
                {props.text.SaveButton}
            </button>
        </div>
    </>
)


// WEBPACK FOOTER //
// ./src/components/PatientOverview/EditComponents/PatientContactInfoEditFooter.tsx